// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/inspection-rerun/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/inspection-rerun/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "Inspection Rerun" })
  return <Page />
}
